import React from 'react'
import NormalizeMedia from '../../utils/NormalizeMedia'
import { StyledImages, StyledMedia, StyledMediaCaption, StyledSide } from './LocationMedia.styled'

export const LocationMediaEnum = {
  1: 'only',
  2: 'pair',
  3: 'tier',
}

const LocationMedia = ({images}) => {
  const handleEnter = (e) => {
    const caption = e.target?.parentNode?.querySelector('.caption')
    if (caption) return (caption.style.display = 'none')
  }

  const handleBlur = (e) => {
    const caption = e.target?.parentNode?.querySelector('.caption')
    if (caption) return (caption.style.display = 'flex')
  }

  const RenderMedia = (length, index) => {
    if(images[index].sys.contentType.sys.id === "contentMedia") {
      return (
        <StyledMedia
          key={index}
          $variant={LocationMediaEnum[length]}
          $position={index}
          onMouseEnter={(e) => handleEnter(e)}
          onMouseLeave={(e) => handleBlur(e)}
        >
          {NormalizeMedia(images[index])}
          {(images[index]?.caption?.caption ||
            images[index]?.altText?.altText) && (
            <StyledMediaCaption
              $variant={LocationMediaEnum[length]}
              $position={index}
              className="caption"
            >
              {images[index]?.caption?.caption || images[index]?.altText?.altText}
            </StyledMediaCaption>
          )}
        </StyledMedia>
      )
    }
    if(images[index].sys.contentType.sys.id === "contentIframe") {
      return (
        <StyledMedia key={index}
                     $variant={LocationMediaEnum[length]}
                     $position={index}
                     onMouseEnter={(e) => handleEnter(e)}
                     onMouseLeave={(e) => handleBlur(e)}>
          <iframe src={`${images[index].iframeUrl}`} allow="microphone; accelerometer; gyroscope; vr; fullscreen; xr-spatial-tracking"/>
        </StyledMedia>
      )
    }

  }

  return (
    <StyledImages $variant={images?.length}>
      {images && images.length === 3 && (
        <>
          {RenderMedia(images.length, 0)}
          <StyledSide>
            {RenderMedia(images.length, 1)} {RenderMedia(images.length, 2)}
          </StyledSide>
        </>
      )}
      {images && images.length !== 3 &&
        images.map((_, index) => RenderMedia(images.length, index))}
    </StyledImages>
  )
}

export default LocationMedia
